<fcom-modal
  [open]="true"
  [fitToContent]="true"
  [fullHeight]="true"
  [buttons]="ModalButtons.CUSTOM"
  [overlayClickable]="true"
  [forceRemainOpen]="true"
>
  <fcom-datepicker
    class="block overflow-hidden rounded-top-large"
    [uiLabels]="'datepicker' | finLocalization"
    [dateLabels]="'date' | finLocalization"
    [titleAreaConfiguration]="{
      title: 'destinationSearch.datepicker.title' | finLocalization,
    }"
    [isDateRange]="(isDateRange$ | async) === true"
    [selectableDatesRange]="selectableDatesRange"
    [selectedDates]="initialSelectedDates$ | async"
    [doneBtnHidden]="true"
    [disabledDateRanges]="disabledDateRanges$ | async"
    (selectedDatesChange)="onSelectedDatesChange($event)"
    (close)="closeModal()"
    [focusHeaderOnInit]="true"
  ></fcom-datepicker>
  <div messageBox *ngIf="(showError$ | async) === true">
    <fcom-notification
      data-testid="select-date-datepicker-error"
      class="block pr-small-t"
      [theme]="NotificationTheme.ALERT"
    >
      {{
        'MMB.reaccommodation.selectDates.noOffersForDate'
          | finLocalization
            : {
                date:
                  (dates[0] ? (dates[0] | finDateFormat: 'DATE') : '') +
                  (dates[1] ? ', ' + (dates[1] | finDateFormat: 'DATE') : ''),
              }
      }}
    </fcom-notification>
  </div>

  <div buttons>
    <div class="valign-middle font-body-2">
      <fcom-button
        [disabled]="(canContinue$ | async) === false || (loading$ | async) === true"
        [loading]="loading$ | async"
        [size]="(isMobile$ | async) ? ButtonSize.LARGE : ButtonSize.MEDIUM"
        [text]="'actions.continue' | finLocalization"
        (clickBtn)="loadCalendarMatrix()"
        [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
        class="mr-xsmall-r right"
        [aria]="{ label: 'ctaButton.loading' | finLocalization, role: 'button' }"
        data-testid="change-flight-modal-load-calendar"
      ></fcom-button>
    </div>
  </div>
</fcom-modal>
